<template>

  <div>

    <link rel="stylesheet" href="../static/stylesheets/screen-ar.css" v-if="this.$i18n.locale == 'ar'">
    <link rel="stylesheet" href="../static/stylesheets/screen-en-US.css" v-if="this.$i18n.locale == 'en'">

    <Pre-Loader v-show="isPreLoading"></Pre-Loader>

    <div class="wrapper" v-show="!isPreLoading">

      <!-- HEADER -->
      <header class="header has-shadow">
        <Main-Header :pre-loading.sync="isPreLoading"></Main-Header>
      </header>

      <!-- ROUTES -->
      <transition name="fade">
        <router-view/>
      </transition>

      <!-- FOOTER -->
      <Main-Footer :pre-loading.sync="isPreLoading"></Main-Footer>

    </div>

  </div>

</template>

<script>
import PreLoader from "./components/modules/PreLoader";
import MainHeader from "./components/modules/MainHeader";
import MainFooter from "./components/modules/MainFooter";
import "flexboxgrid/dist/flexboxgrid.min.css";

export default {
  name: "app",
  data() {
    return {
      isPreLoading: true
    };
  },
  components: {
    PreLoader,
    MainHeader,
    MainFooter
  }
};
</script>

<style>
object,
svg {
  pointer-events: all;
}
</style>



// WEBPACK FOOTER //
// src/App.vue